import { render, staticRenderFns } from "./statistics-data.pug?vue&type=template&id=584cdda4&scoped=true&lang=pug&"
import script from "./statistics-data.ts?vue&type=script&lang=ts&"
export * from "./statistics-data.ts?vue&type=script&lang=ts&"
import style0 from "./statistics-data.styl?vue&type=style&index=0&id=584cdda4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584cdda4",
  null
  
)

export default component.exports